import { useMantineTheme } from "@mantine/core";
import { useEffect, useState } from "react";

const useSmallScreen = () => {
  const theme = useMantineTheme();
  const breakpoint = parseInt(theme.breakpoints.sm, 10);
  const [isSmallScreen, setIsSmallScreen] = useState(
    window.innerWidth <= breakpoint
  );

  useEffect(() => {
    const handleResize = () =>
      setIsSmallScreen(window.innerWidth <= breakpoint);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isSmallScreen;
};

export default useSmallScreen;
